export * from './Footer';
export * from './FooterSlotsRepository';
export * from './FooterSlotsValue';
export * from './FooterReinsuranceValue';
export * from './FooterLinksValue';
export * from './FooterSocialNetworkValue';
export * from './footerLegalLinks';
export * from './FooterAdditionalMentions';
